import './App.css';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Layout from './Commons/Layout';
import Login from './Component/Login';
import Homepage from './Component/Homepage';
import EventDetails from './Component/EventDetails';
import { useState } from 'react';

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  // Function to refresh sidebar
  const handleRefreshSidebar = () => setRefreshKey(prev => prev + 1);

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Login routes without layout */}
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />

          {/* Protected routes wrapped with Layout */}
          {/* <Route path="/Homepage" element={<Layout><Homepage /></Layout>} /> */}
          {/* Protected routes wrapped with Layout */}
          <Route
            path="/Homepage"
            element={
              <Layout sidebarKey={refreshKey}>
                <Homepage onEventCreated={handleRefreshSidebar} />
              </Layout>
            }
          />
          <Route
            path="/Event/:id"
            element={
              <Layout sidebarKey={refreshKey}>
                <EventDetails onEventCreated={handleRefreshSidebar} />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;